import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Divider, Icon, Input, message, Row, Select, Tag } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { currencyVND, dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { PURCHASE_ORDER } from '../../services/endpoint';
import './style.scss';
import { useHistory } from 'react-router-dom';
import { PURCHASE_ORDER_STATUS, REFUND_STATUS } from '../../utils/const';

const { Option } = Select;

const DEFAULT_PAGE = {
  currentPage: 1,
  perpage: 20
};

// let CUR_UPDATE_ID = null;

export default () => {

  const [ds, setDs] = useState([]);
  // const [showPopup, setShowPopup] = useState(false);
  // const [note, setNote] = useState('');
  const [searchValues, setSearchValues] = useState({});
  const [page, setPage] = useState({
    ...DEFAULT_PAGE,
    total: 0
  });

  const history = useHistory();

  useEffect(() => {
    const init = async () => {
      try {
        window.setLoading(true);
        const apiList = [await CommonService.get(PURCHASE_ORDER, {
          page: page.currentPage - 1,
          size: page.perpage,
          type: 'REFUND'
        })];
        const resp = Promise.all(apiList);
        const [purchaseOrderList] = await resp;
        setDs(purchaseOrderList.data?.contents);
        setPage({ ...page, total: purchaseOrderList.data?.totalElements });
      } catch (error) {
        message.error(error?.data?.message);
      } finally {
        window.setLoading(false);
      }
    };
    init();
  }, []);

  const onSearch = async (pageParam = DEFAULT_PAGE) => {
    try {
      const param = { ...searchValues, type: 'REFUND', page: pageParam.currentPage - 1, size: pageParam.perpage };
      window.setLoading(true);
      const resp = await CommonService.get(PURCHASE_ORDER, param);
      setDs(resp.data?.contents);
      setPage({
        total: resp.data?.totalElements,
        ...pageParam
      });
    } catch (error) {
      message.error(error?.data?.message);
    } finally {
      window.setLoading(false);
    }
  };

  const renderStatus = (status) => {
    const currStatus = PURCHASE_ORDER_STATUS.find(el => el.value == status);
    return currStatus && <Tag style={{ width: '100px' }} color={currStatus.color}>{currStatus.name}</Tag>;
  };

  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      width: 60,
      align: 'center',
      render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
    },
    {
      title: 'Mã đơn hoàn trả',
      dataIndex: 'code',
			align: 'center',
      render: (text, record) => {
        return <Button style={{ padding: '0' }} type={'link'} onClick={() => gotoDetail(record.parentId)}>{text}</Button>;
      }
    },
    {
      title: 'Ngày tạo đơn',
      dataIndex: 'createdDate',
      width: 200,
      align: 'center',
      render: (text) => (<span>{dateToString(text)}</span>)
    },
    {
      title: 'Tên nhà cung cấp',
      dataIndex: 'supplierName',
      width: 'fit-content',
      align: 'center'
    },
    {
      title: 'Chi nhánh nhập',
      dataIndex: 'branchName',
      align: 'center'
    },
    // {
    //   title: 'Trạng thái',
    //   dataIndex: 'refundStatus',
    //   width: 100,
    //   align: 'center',
    //   render: (status) => renderStatus(status)
    // },
    {
      title: 'Tỉ lệ hoàn tiền',
      dataIndex: 'refundStatus',
      width: 'fit-content',
      align: 'center',
      render: (refundStatus) => {
				switch (refundStatus) {
					case 1:
						return <Tag style={{ width: '120px' }} color="#0db473">Đã hoàn toàn bộ</Tag>
					case 2:
						return <Tag style={{ width: '120px' }} color="#e49c06">Đã hoàn 1 phần</Tag>
					default:
						return <Tag style={{ width: '120px' }} color="#5364fe">Chưa hoàn</Tag>
				}
			}
    },
    {
      title: 'Tổng tiền hoàn',
      dataIndex: 'price',
      width: 'fit-content',
      align: 'center',
      render: (text) => (<span>{currencyVND(text)}</span>)
    },
    {
      title: 'Lý do hoàn trả',
      dataIndex: 'note',
      className: 'header-center-align',
      width: 'fit-content',
    }
  ];

  const handleChange = (value, key) => {
    searchValues[key] = value.toString();
    setSearchValues({ ...searchValues });
  };

  const goToCreate = () => {
    history.push('/refund/create');
  };

  const gotoDetail = (id) => {
    history.push('/purchase-order/' + id);
  };

	const onEnter = (evt) => {
		if (evt.key === 'Enter') {
			onSearch(DEFAULT_PAGE);
		}
	};

  return (<Fragment>
      <Row className="mb-10" id={'product__action'}>
				<Col style={{visibility: 'hidden'}}>
          <div>
            <Divider type="vertical" />
            <Icon type="download" />
            <span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Xuất file')}>Xuất file</span>
            <Divider type="vertical" />
            <Icon type="upload" />
            <span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Nhập file')}>Nhập file</span>
          </div>
        </Col>
        <Col>
          <Button type="primary" style={{ width: '180px' }} id={'btn-create-product'} icon="plus"
                  onClick={goToCreate}>Tạo đơn hoàn trả</Button>
        </Col>
      </Row>
      <Row>
        <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
          <Input
            style={{ height: '32px' }}
            placeholder="Tìm kiếm theo mã đơn nhập, SĐT, tên, mã NCC"
            allowClear
            onChange={(value) => handleChange(value.target.value, 'value')}
						onKeyDown={onEnter}
          />
          <Select
            mode="multiple"
            placeholder="Trạng thái"
            onChange={(value) => handleChange(value, 'refundStatus')}
            style={{ width: '35%' }}
            allowClear
            maxTagCount={1}
            maxTagTextLength={10}
          >
            {REFUND_STATUS.map(el => (<Option key={el.value}>{el.name}</Option>))}
          </Select>
          <DatePicker.RangePicker
            allowClear
            placeholder={['Từ ngày', 'Đến ngày']}
            style={{ width: '600px' }}
            onChange={(value) => {
              const arr = value.map(el => dateToString(el, 'YYYY-MM-DD'));
              handleChange(arr[0], 'from');
              handleChange(arr[1], 'to');
            }} />
          <Button type="primary"
                  style={{ width: '150px' }}
                  onClick={() => onSearch(DEFAULT_PAGE)}>
            Tìm kiếm
          </Button>
        </div>
      </Row>
      <TableCommon bordered={true}
                   page={page}
                   setPage={setPage}
                   datasource={ds}
                   columns={columns}
                   onSearch={onSearch}
      />
      {/*<Modal*/}
      {/*	title="Cập nhật ghi chú"*/}
      {/*	visible={showPopup}*/}
      {/*	onOk={() => {*/}
      {/*		setShowPopup(false);*/}
      {/*	}}*/}
      {/*	onCancel={() => {*/}
      {/*		setShowPopup(false);*/}
      {/*	}}*/}
      {/*>*/}
      {/*	<p>Nội dung ghi chú: </p>*/}
      {/*	<TextArea rows={6} value={note} onChange={(e) => setNote(e.target.value)} />*/}
      {/*</Modal>*/}
    </Fragment>

  );
};
